import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import datePicker from '../../component/dccore-form/datePicker.vue'

if ($('#pricelist_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#pricelist_form',
    components: {
      RingLoader,
      DcForm,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      datePicker
    },
    mixins: [mixins],
    data: {
      priceListId : null,
      loading: 0,
      brands: [],
      packages: [],
      priceList: {
        id: null,
        dateTo: new Date(),
        dateFrom: new Date()
      },
      items: [
        {
          size: {
            id: null,
            name: null,
          },
          priceItem: {
            id: null,
            price: null,
          }
        }
      ],
      form: {
        options: {
          errors: {},
        }
      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.priceListId = $('#entity_id').val()
        this.getPriceList()
      }
      this.getBrands()
      this.getPriceItems()
    },
    methods: {
      updatePriceList: function (redirect) {
        let url = Routing.generate('api_patch_price_list', { id: this.priceListId })

        Vue.http.patch(url, {
          'data': this.priceList,
          'items': this.items,
        }).then(() => {
          this.getPriceItems()

          if (redirect) {
            $(location).attr('href', Routing.generate('price_list_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(this.trans('form.updated'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      createPriceList: function (redirect) {
        let url = Routing.generate('api_post_price_list', { id: this.priceListId })

        Vue.http.post(url, {
          'data': this.priceList,
          'items': this.items,
        }).then(() => {
          this.getPriceItems()

          if (redirect) {
            $(location).attr('href', Routing.generate('price_list_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(this.trans('form.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getPriceList: function () {
        this.loading++

        let url = Routing.generate('api_get_price_list', { id: this.priceListId,
          context: 'price' })

        Vue.http.get(url).then(response => {
          this.priceList = response.data
          this.loading--

          this.getPackages(this.priceList.brand)
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      reloadPackages(event) {
        this.priceList.package = null
        this.getPackages(event.id)
      },
      getPackages(brandId) {
        this.loading++

        let url = Routing.generate('api_get_packages_by_brand', {
          brandId: brandId,
          context: 'dropdown'
        })

        this.$http.get(url).then(response => {
          this.packages = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        this.loading++
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getPriceItems() {
        this.loading++

        let url = Routing.generate('api_get_price_lists_price_items', {
          priceListId: this.priceListId || 0,
          context: 'price'
        })

        this.$http.get(url).then(response => {
          this.items = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      trans(name) {
        return Translator.trans(name)
      },
    }
  })
}
